import React from "react";
import { currentTheme, smetaStore } from "../../atoms";
import datePickerIndicatorIcon from "../../static/images/icons/date-picker-indicator.svg";

// eslint-disable-next-line @typescript-eslint/naming-convention
function StyleSmetaComponents() {
  const theme = smetaStore.get(currentTheme);
  return (
    <style>{`
    :root {
    // --indicatorColor: #faf9f5;
    --accent-blue: rgb(98, 142, 184);
    --bg-blue:#f8f8f8;
    --accent-light:#faf9f5;
    --font-color-blue:#ffffff;
    --bg-light:#faf9f5;
    --selected-light:#dcd8cc;
    --font-color-light:#616161;
    --accordion-light: #dcd8cc;
    --header-light: #dcd8cc;
    --iconButtonColor: #ffffff;
    --iconButtonColor-light:#616161;
    --iconColorStimate: rgb(4, 4, 4);
    --iconColorStimate-light: rgb(179, 173, 151);
    --darker-light:#c6ba97;
}
.setfont
{
    font: 300 13px/19px 'Open Sans','Helvetica Neue',helvetica,arial,verdana,sans-serif;
    letter-spacing :0px;
}
.ellipsis
{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.hidden{
    display:none !important;
}

.date-range{
    background-color: rgba(25, 118, 210, 0.12);
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-light{
    background-color: #eeeeee;
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-start{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-start-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
${
  theme === "light"
    ? `
    .Mui-selected{
    color: #000000 !important;
    background-color: rgb(220, 216, 204) !important;
    font-weight: 500;
    }
    `
    : `
    .Mui-selected{
    color: #fff;
    background-color: #1976d2;
    font-weight: 500;
    }
    `
}

.date-range-end{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
.date-range-end-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-current{
    outline: 1px solid;
    }

input[type=date]::-webkit-calendar-picker-indicator {
    background-image: url("${datePickerIndicatorIcon}");
}
    `}</style>
  );
}

export { StyleSmetaComponents };
